export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Premier (1).f6eb52f4.gif","height":300,"width":300,"blurWidth":0,"blurHeight":0};